import { useFeatureIsOn } from "@growthbook/growthbook-react";

const MY_TEAM_PSEUDOCHANNEL_FEATURE_FLAG = "my-team-pseudochannel";
const MY_TEAM_PSEUDOCHANNEL_ANALYTICS_FEATURE_FLAG = "my-team-pseudochannel-analytics";

export function useIsMyTeamPseudoChannelEnabled(): boolean {
	return useFeatureIsOn(MY_TEAM_PSEUDOCHANNEL_FEATURE_FLAG);
}

export function useIsMyTeamPseudoChannelAnalyticsEnabled(): boolean {
	return useFeatureIsOn(MY_TEAM_PSEUDOCHANNEL_ANALYTICS_FEATURE_FLAG);
}
